exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/deep/ .btn-select {\n  height: 32px;\n    max-width: 200px;\n    width: 200px;\n}\n\n/deep/ input {\n  /* width: 150px!important; */\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/pages/admin/qrcode/static_report/static_report.component.css
// module id = ../../../../../src/app/pages/admin/qrcode/static_report/static_report.component.css
// module chunks = 3